// Stable, bounded route metadata values. Keep the API allowlist and coverage test in sync.
export const SCREEN_KEYS: readonly string[] = [
  'About',
  'AccountDeletion',
  'AdminAppearance.Edit',
  'AdminAppearance.List',
  'AdministrationFeedback',
  'AdministrationNotifications',
  'AdministrationUserHistory',
  'AdministrationUserOverview',
  'AdministrationUsers',
  'Appearance.Clone',
  'Appearance.Edit',
  'Appearance.List',
  'Audits',
  'Audits.Overview',
  'Audits.database',
  'Audits.files',
  'Basket',
  'BasketEditor.Edit',
  'BasketEditor.New',
  'BasketJournal',
  'BasketJournalDetail',
  'BasketNeedAccess',
  'BasketNeedHistory',
  'BasketPurchase',
  'Checkout',
  'ContainerEditor.Edit',
  'ContainerEditor.New',
  'ContainerShareEditor',
  'Containers',
  'Containers.Contents',
  'Containers.Roots',
  'Favorites',
  'Feedback',
  'ForgotPassword',
  'Guide.administration-audits',
  'Guide.appearance',
  'Guide.basket-needs',
  'Guide.basket-planned-price',
  'Guide.basket-purchase-consumption',
  'Guide.basket-purchase-photo',
  'Guide.bulk-move',
  'Guide.copy-item',
  'Guide.correct-packaging',
  'Guide.favorites',
  'Guide.find-items',
  'Guide.inventory-groups',
  'Guide.item-history',
  'Guide.item-prices',
  'Guide.items',
  'Guide.move-inventory',
  'Guide.price-history',
  'Guide.privacy-settings',
  'Guide.quick-navigation',
  'Guide.regional-settings',
  'Guide.shared-purchases',
  'Guide.standard-color-schemes',
  'Guide.storage-organization',
  'Guide.write-off',
  'Guides',
  'GuidesIndex',
  'Home',
  'HomeInventoryGuide',
  'ItemDetails',
  'ItemEditor.Clone',
  'ItemEditor.Edit',
  'ItemEditor.New',
  'Landing',
  'LastChanges',
  'Login',
  'Logout',
  'Moderation',
  'Onboarding',
  'OperationalSettings',
  'OperationalSettings.ai',
  'OperationalSettings.application',
  'OperationalSettings.diagnostics',
  'OperationalSettings.history',
  'OperationalSettings.storage',
  'PaymentProviders',
  'People',
  'People.received',
  'People.sent',
  'People.trusted-contacts',
  'PricingPlans',
  'Privacy',
  'PublicItemDetail',
  'PublicItems',
  'PublicationRequests',
  'PublicationReview',
  'QrLabels',
  'QrLabelsPackageEditor',
  'QrLabelsProfileEditor.Edit',
  'QrLabelsProfileEditor.New',
  'QrLabelsProfiles',
  'Register',
  'Relocation',
  'Reports.Expired',
  'Reports.Expiring',
  'ResetPassword',
  'Settings',
  'ShopEditor.Edit',
  'ShopEditor.New',
  'Shops',
  'SsrDemo',
  'SubscriptionSummary',
  'Terms',
  'VerifyEmail',
  'WriteOff',
];
